// extracted by mini-css-extract-plugin
module.exports = {"NavbarParent":"Navbar_styles_NavbarParent__MVcc7","rightlinks_parent":"Navbar_styles_rightlinks_parent__17Xer","links":"Navbar_styles_links__2-3yB"};